/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { MetaTxGateway } from "./MetaTxGateway";

export class MetaTxGatewayFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<MetaTxGateway> {
    return super.deploy(overrides || {}) as Promise<MetaTxGateway>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): MetaTxGateway {
    return super.attach(address) as MetaTxGateway;
  }
  connect(signer: Signer): MetaTxGatewayFactory {
    return super.connect(signer) as MetaTxGatewayFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MetaTxGateway {
    return new Contract(address, _abi, signerOrProvider) as MetaTxGateway;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address payable",
        name: "relayerAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "functionSignature",
        type: "bytes",
      },
    ],
    name: "MetaTransactionExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_addr",
        type: "address",
      },
    ],
    name: "addToWhitelists",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "functionSignature",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "sigR",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "sigS",
        type: "bytes32",
      },
      {
        internalType: "uint8",
        name: "sigV",
        type: "uint8",
      },
    ],
    name: "executeMetaTransaction",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_version",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_chainIdL1",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_addr",
        type: "address",
      },
    ],
    name: "isInWhitelists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_addr",
        type: "address",
      },
    ],
    name: "removeFromWhitelists",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
